<template>
    <v-container fluid>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" :info="info" v-on:close="showDismissibleAlert=false" />
        <v-form ref="addForm" v-model="valid">
            <v-row>
                <v-col>
                    <v-skeleton-loader v-if="loading" class="mx-auto" type="text" :dark="$store.getters.getColorPalette().isDark" ></v-skeleton-loader>
                    <!-- <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="month"
                        persistent
                        width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="month"
                            label="Select Month"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            dense 
                            outlined
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="month" type="month" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog.save(month)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog> -->
                    <v-select 
                        v-if="!loading"
                        dense 
                        outlined 
                        :dark="$store.getters.getColorPalette().isDark"
                        :color="$store.getters.getColorPalette().inputTextColor"
                        :menu-props="{dark: $store.getters.getColorPalette().isDark}" 
                        v-model="month" 
                        :items="monthOptions" 
                        multiple
                        :label="$store.getters.getTextMap().month" 
                        item-text="label"
                        item-value="value" 
                        :rules="[rules.required]">
                    </v-select>
                </v-col>
                <v-col>
                    <v-select 
                        v-if="!loading"
                        dense 
                        outlined 
                        :dark="$store.getters.getColorPalette().isDark"
                        :color="$store.getters.getColorPalette().inputTextColor"
                        :menu-props="{dark: $store.getters.getColorPalette().isDark}" 
                        v-model="day_of_week" 
                        :items="weekOptions" 
                        multiple
                        :label="$store.getters.getTextMap().day_of_week" 
                        item-text="label"
                        item-value="value" 
                        :rules="[rules.required]">
                    </v-select>
                </v-col>
                <v-col>
                    <v-text-field
                        v-if="!loading"
                        v-model="form.target_val"
                        :counter="3"
                        :label="$store.getters.getTextMap().target_value" 
                        dense
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col>
                    <v-btn v-if="!loading" :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().accentCode" text small outlined @click="onSubmit">{{$store.getters.getTextMap().add}}</v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>
<script>
import axios from 'axios';
import InfoAlert from '@/components/InfoAlert'
import FormRules from '@/utillities/FormRules'
export default {
    name:'AddTargetData',
    props:['target'],
    components:{
        InfoAlert,   
    },
    data(){
        return {
            form:{},
            loading:false,
            info:null,
            showDismissibleAlert:false,
            valid:false,
            menu: false,
            modal: false,
            day_of_week:[],
            month:[],
            monthOptions:[
                { label: 'January', value: 1 },
                { label: 'February', value: 2 },
                { label: 'March', value: 3 },
                { label: 'April', value: 4 },
                { label: 'May', value: 5 },
                { label: 'June', value: 6},
                { label: 'July', value: 7},
                { label: 'August', value: 6},
                { label: 'September', value: 9},
                { label: 'October', value: 10},
                { label: 'November', value: 11},
                { label: 'December', value: 12},
            ],
            weekOptions:[
                { label: 'Sunday', value: 6 },
                { label: 'Monday', value: 0 },
                { label: 'Tuesday', value: 1 },
                { label: 'Wednesday', value: 2 },
                { label: 'Thursday', value: 3 },
                { label: 'Friday', value: 4},
                { label: 'Saturday', value: 5},
            ],
            rules:FormRules.rules
        }
    },
    methods:{
        async onSubmit(){
            try {
                const isValid = await this.$refs.addForm.validate();
                if (isValid) {
                    this.loading = true;
                    let proceed = true;
                    let payload = {
                        target_id: this.target.target_id,
                        target_val: this.form.target_val
                    };
                    for (let i of this.month) {
                        if (!proceed) break;
                        for (let j of this.day_of_week) {
                            if (!proceed) break;
                            payload["month"] = i;
                            payload["day_of_week"] = j;
                            try {
                                const response = await axios.post(
                                    this.$store.state.api + "addTargetData",
                                    payload,
                                    { headers: { Authorization: 'Bearer ' + this.$store.state.jwt } }
                                );
                                if (response.data.status !== "success") {
                                    proceed = false;
                                    this.info = response.data.msg;
                                    this.showDismissibleAlert = true;
                                    this.loading = false;
                                }
                            } catch (err) {
                                proceed = false;
                                this.info = err.message || "Error occurred during request.";
                                this.showDismissibleAlert = true;
                                this.loading = false;
                            }
                        }
                    }
                    if (proceed) {
                        this.$store.dispatch("refreshTargetData")
                        this.$emit('add')  
                        this.info = "Data added";
                        this.showDismissibleAlert = true;
                        this.info = "Data added";
                        this.onReset()
                        this.$emit('close')
                    }
                    this.loading=false
                }
            } catch (error) {
                this.onReset();
                this.info = error.message || "Unexpected error.";
                this.showDismissibleAlert = true;
                this.loading = false;
            }
            // this.$refs.addForm.validate()
            // if(this.valid){
            //     console.log(this.month,"month")
            //     console.log(this.day_of_week,"day of week")
            //     this.loading = true
            //     this.form.target_id=this.target.target_id
            //     axios.post(this.$store.state.api + "addTargetData", this.form,{headers: {Authorization: 'Bearer '+ this.$store.state.jwt}})
            //     .then(response => {
            //     if (response.data.status == "success") {
            //         this.$store.dispatch("refreshTargetData")
            //         this.$emit('add')       
            //         this.info = "Data added";
            //         this.showDismissibleAlert = true;
            //         this.loading = false;
            //         this.onReset()
            //         this.$emit('close')
            //     } else {
            //         this.info = response.data.msg;
            //         this.showDismissibleAlert = true;
            //     }
            //     this.loading = false;
            //     })
            //     .catch(error => {
            //         this.onReset()
            //         this.info = error;
            //         this.showDismissibleAlert = true;
            //         this.loading = false;
            //     });
            // }
        },
        onReset(){
            this.$refs.addForm.reset()
            this.$emit('close')                
        }
    }
}
</script>